import { Link, useLocation } from 'react-router-dom';
import SiteHeader from '@/components/feature/SiteHeader';
import SiteFooter from '@/components/feature/SiteFooter';
import SeoHead from '@/components/feature/SeoHead';

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="min-h-screen bg-background-50 flex flex-col">
      <SeoHead
        title="页面不存在 - 深瞳爆料官网"
        description="你访问的页面不存在或已被移动。返回首页可查看深瞳爆料官网的联系方式、投稿邮箱、商务合作与官方账号信息。"
        keywords="爆料官网,页面不存在,联系方式,投稿邮箱"
        path="/404"
      />
      <SiteHeader />
      <main className="flex-1 flex items-center">
        <div className="w-full px-5 md:px-8 lg:px-12 py-24 md:py-32">
          <div className="max-w-[1400px] mx-auto grid grid-cols-1 lg:grid-cols-12 gap-10 items-center">
            <div className="lg:col-span-7">
              <p className="font-mono text-xs tracking-[0.3em] uppercase text-primary-500">
                Error 404
              </p>
              <h1 className="mt-5 font-heading text-3xl md:text-5xl font-black leading-tight text-foreground-950">
                这个页面不在档案里
              </h1>
              <p className="mt-5 text-sm md:text-base leading-relaxed text-foreground-600 max-w-xl">
                你访问的地址可能已经调整，或者链接输入有误。可以返回首页，或直接前往联系方式页找到我们公布的官方渠道。
              </p>
              <p className="mt-4 font-mono text-xs text-foreground-400 break-all">
                {location.pathname}
              </p>
              <div className="mt-9 flex flex-col sm:flex-row gap-3">
                <Link
                  to="/"
                  className="inline-flex items-center justify-center gap-2 bg-primary-500 hover:bg-primary-600 text-background-50 text-sm font-medium px-6 py-3.5 rounded-md transition-colors whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-arrow-left-line"></i>
                  返回首页
                </Link>
                <Link
                  to="/contact"
                  className="inline-flex items-center justify-center gap-2 border border-foreground-950/20 hover:border-primary-500 hover:text-primary-600 text-foreground-900 text-sm font-medium px-6 py-3.5 rounded-md transition-colors whitespace-nowrap cursor-pointer"
                >
                  查看联系方式
                </Link>
              </div>
            </div>
            <div className="lg:col-span-5">
              <p className="font-heading text-[7rem] md:text-[11rem] leading-none font-black text-background-200 select-none">
                404
              </p>
            </div>
          </div>
        </div>
      </main>
      <SiteFooter />
    </div>
  );
}